function TextProps(props: any) {
  const { data } = props;
  return (
    <section>
      {data.map((item: { text: string }, i: any) => (
        <div className="text-box" key={i}>
          <p> {item.text} </p>
        </div>
      ))}
    </section>
  );
}

export default TextProps;
